import { ToolCard } from 'odc-shared/components';
import React, { useMemo } from 'react';

import website from '@src/constants/website';
import useMobxSelector from '@src/hooks/useMobxSelector';
import { getCategoryFirstPid } from '@src/utils/helpCenter';

import './index.scss';

interface GettingStartedProps {
  platform: 'publisher' | 'advertiser';
  setPid: (pid: string | undefined) => void;
}

function getImageUrl(path: string) {
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  // 相对路径，拼接域名
  return new URL(path, website.staticBaseUrl).href;
}

const GettingStarted: React.FC<GettingStartedProps> = ({
  platform,
  setPid,
}) => {
  const catalogsByPlatform = useMobxSelector((stores) => stores.helpCenterStore.catalogsByPlatform);

  const catalogsData = useMemo(() => {
    const catalogs = catalogsByPlatform[platform];
    if (!catalogs) return [];
    return catalogs.map((catalog) => ({
      id: catalog.id,
      title: catalog.name || '',
      desc: catalog.description || '',
      pid: getCategoryFirstPid(catalog),
      icon: getImageUrl(catalog.icon || ''),
    }));
  }, [catalogsByPlatform, platform]);

  return (
    <div className="odc-page-getting-started">
      <div className="odc-page-content">
        <p className="article-title">Getting started</p>
        <div className="article-content">
          <div className="tool-card-group">
            {
              catalogsData.map((catalog) => (
                <ToolCard
                  key={catalog.id}
                  icon={catalog.icon}
                  name={catalog.title}
                  desc={catalog.desc}
                  onClick={() => setPid(catalog.pid)}
                />
              ))
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default GettingStarted;